import React, { useRef, useEffect } from 'react';

const ChatInput = ({ 
  value, 
  onChange, 
  onSend, 
  disabled = false, 
  placeholder = "Type your message...",
  maxLength = 500 
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && !disabled) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const handleInput = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
  };

  return (
    <div className="flex-1 relative">
      <textarea
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        onInput={handleInput}
        placeholder={placeholder}
        className="w-full p-4 pr-16 border border-gray-300 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-[#831f82] focus:border-[#831f82] transition-all duration-200 shadow-sm hover:shadow-md"
        rows="1"
        disabled={disabled}
        maxLength={maxLength}
        style={{ minHeight: '52px', maxHeight: '120px' }}
      />
    </div>
  );
};

export default ChatInput;